import { useContext, useState, useEffect } from "react";
import HeMapboxUrbica from "../../../components/HeMapboxUrbica";
import CensusLayer from "../../../components/HeMapboxUrbica/components/CensusLayer";
import Popup from "../../../components/HeMapboxUrbica/components/Popup";
import { getBufferedExtent } from "../../../components/HeMapboxUrbica/ExtentHelperFunctions";
import { Source, Layer } from "@urbica/react-map-gl";
import MapPopup from "./MapPopup";

import { actions } from "../context/AppProvider";
import appContext from "../context/appContext";
import { useViewport } from "../../../components/ReactContext_Viewport";
import useExtentOfGeos from "../../../hooks/useExtentOfGeos";

import some from "lodash/some";

const Map = () => {
    const { screenSize, appHeight } = useViewport();
    const { state, dispatch } = useContext(appContext);
    const [hoveredFtr, set_hoveredFtr] = useState(null);

    let mapHeight = 500;

    if (screenSize === "mobile") {
        mapHeight = appHeight - 186;
    } else {
        const mainElement = document.getElementsByClassName("layout_container_main")[0];
        if (mainElement) {
            mapHeight = mainElement.offsetHeight;
        }
    }

    if (!state.mapExtent) return null;

    return (
        <div style={{ width: "100%", height: mapHeight }}>
            <HeMapboxUrbica
                mapStyle="mapbox://styles/headmin/ckm4h3rhz9u2z17o0ytb2i8w3"
                cursor_default={state.mapCursor_default}
                cursor_isHovering={state.mapCursor_isHovering}
                extent={state.mapExtent}
                screenSize={screenSize}
                // onMapIdle={onMapIdle}
                zoomGeoIds={state.selectedGeos.map((sg) => sg.id)}
            >
                {hoveredFtr && (
                    <Popup closeButton={false} closeOnClick={false} maxWidth="600px">
                        <MapPopup hoveredFtr={hoveredFtr} />
                    </Popup>
                )}
                <Source id={"usfs"} type="vector" url={"mapbox://headmin.crv7hhq9"} />
                {/* <Source id={"usfsPointLabels"} type="vector" url={"mapbox://headmin.b37gzi6t"} /> */}
                <Layer
                    id={"usfsReference"}
                    source-layer={"forest_2020"}
                    before="poi-scalerank4-l15"
                    source="usfs"
                    type="fill"
                    paint={{
                        "fill-color": "rgba(94,131,91,0.15)",
                        "fill-outline-color": "rgba(94,131,91,0.4)",
                    }}
                />
                <Layer
                    id={"usfsSelected"}
                    source-layer={"forest_2020"}
                    before="poi-scalerank4-l15"
                    source="usfs"
                    type="fill"
                    paint={{
                        "fill-color": "rgba(94,131,91,0.2)",
                        "fill-outline-color": "black",
                    }}
                    filter={["==", "id", state.searchFeature.id]}
                />

                <Layer
                    id={"usfsReference_labels"}
                    source-layer={"forest_2020"}
                    source="usfs"
                    type="symbol"
                    minzoom={8}
                    paint={{
                        "text-halo-color": "lightgrey",
                        "text-halo-width": 3,
                        "text-color": "rgba(94,131,91,1)",
                        "text-halo-blur": 0,
                    }}
                    layout={{
                        "text-field": "{name}",
                        "text-transform": "uppercase",
                        "text-letter-spacing": 0.1,
                        "text-max-width": 12,
                        "text-font": ["DIN Offc Pro Bold", "Arial Unicode MS Bold"],
                        "text-padding": 10,
                        "text-size": 8,
                    }}
                />

                <CensusLayer
                    layerName={"county"}
                    before="housenum-label"
                    color_default_border={"rgba(143, 43, 0,0.25)"}
                    color_default_fill={"transparent"}
                    color_hover_border={"rgba(180,180,180,1)"}
                    color_hover_fill={"rgba(143, 43, 0, 0.25)"}
                    color_select_border={"rgb(143, 43, 0)"}
                    color_select_fill={"transparent"}
                    onClick={(ftr) => {
                        const ftrId = ftr.id;
                        if (some(state.selectedGeos, { id: ftrId })) {
                            dispatch({ type: actions.REMOVE_GEO, id: ftrId });
                        } else {
                            dispatch({ type: actions.ADD_GEO, id: ftrId, name: ftr.properties.name });
                        }
                    }}
                    onHover={(ftr) => {
                        set_hoveredFtr(ftr);
                    }}
                    selectedFeatures={state.selectedGeos.map((sg) => ({
                        id: sg.id,
                        geo_level: "county",
                    }))}
                    color_label={"rgb(143, 43, 0)"}
                    lineWidth_selectLayer={3}
                    suppressLabels={false}
                    highlightFeature={state.highlightedGeo}
                />
            </HeMapboxUrbica>
        </div>
    );
};

export default Map;
